export default "__VITE_ASSET__D$VFypNU__"